module.exports = __webpack_public_path__ + "img/btn/button-secondary-normal.png";


//////////////////
// WEBPACK FOOTER
// ./img/btn/button-secondary-normal.png
// module id = 51
// module chunks = d-game